import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineStyleConfig} from '@chakra-ui/styled-system';
import {useStyleConfig} from '@chakra-ui/system';
import {mode} from '@chakra-ui/theme-tools';

import {components as componentsDark} from '../../../design-tokens/dark';
import {components, core} from '../../../design-tokens/light';
import {getCoreValueAsThemeToken} from '../../types';

const buttonTheme = components.colors.components.buttons[`icon-button`];
const buttonDarkTheme = componentsDark.colors.components.buttons[`icon-button`];

// TODO: unite with button theme
const IconButtonTheme = defineStyleConfig({
  baseStyle: {
    // ...baseStyle,
    boxShadow: `none`,
    p: 0,
    _disabled: {
      cursor: `not-allowed`,
    },
  },
  defaultProps: {
    variant: `secondary`,
  },
  sizes: {
    lg: {
      w: 48,
      h: 48,
      minW: 48,
      // icon size 24
      fontSize: `2xl`,
    },
    md: {
      w: 40,
      h: 40,
      minW: 40,
      // icon size 24
      fontSize: `2xl`,
    },
    sm: {
      w: 32,
      h: 32,
      minW: 32,
      // icon size 20
      fontSize: `xl`,
    },
    xs: {
      w: 24,
      h: 24,
      // icon size 16
      fontSize: `lg`,
    },
  },
  variants: {
    secondary: (props: StyleFunctionProps) => {
      const disabled = {
        bg: mode(buttonTheme[`background-disabled`], buttonDarkTheme[`background-disabled`])(props),
        color: mode(buttonTheme[`icon-disabled`], buttonDarkTheme[`icon-disabled`])(props),
      };

      return {
        color: mode(buttonTheme[`icon-default`], buttonDarkTheme[`icon-default`])(props),
        bg: `transparent`,
        borderRadius: getCoreValueAsThemeToken(core, `radii.radius-rounded`),
        _hover: {
          color: mode(buttonTheme[`icon-hover`], core.colors.brand.primary[`400`])(props),
          _disabled: disabled,
        },
        _focus: {
          border: `1px solid`,
          bg: mode(buttonTheme[`background-focus`], buttonDarkTheme[`background-focus`])(props),
          borderColor: mode(buttonTheme[`stroke-focus`], buttonDarkTheme[`stroke-focus`])(props),
          _disabled: disabled,
        },
        _disabled: disabled,
        _active: {
          bg: mode(
            components.colors.components.buttons[`icon-button`][`background-pressed`],
            componentsDark.colors.components.buttons[`icon-button`][`background-pressed`],
          )(props),
          // TODO: ask design to have deisgn token for dark mode
          color: mode(buttonTheme[`icon-hover`], core.colors.brand.primary[`400`])(props),
          _disabled: disabled,
        },
      };
    },
  },
});

export default IconButtonTheme;

export const useIconButtonStyleConfig = (props: Parameters<typeof useStyleConfig>[1]) =>
  useStyleConfig(`IconButton`, props);
